import React from 'react';
import FooterOne from '../common/footer/FooterOne';
import HeaderOne from '../common/header/HeaderOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import BreadCrumbOne from '../elements/breadcrumb/BreadCrumbOne';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import SEO from '../common/SEO';
import { useLanguage } from '../context/LanguageContext';
import { Features } from '../assets/features/Features';


const PrivacyPolicy = () => {
    const { language } = useLanguage();

    return (
        <>
            <SEO title={Features.PRIVACY_POLICY_PAGE.TITLE[language]} />
            <ColorSwitcher />
            <main className="main-wrapper">
                <HeaderOne />
                <BreadCrumbOne 
                title={Features.PRIVACY_POLICY_PAGE.BREADCRUMB_TITLE[language]}
                page={Features.PRIVACY_POLICY_PAGE.TITLE[language]}
                />
                <div className="section-padding privacy-policy-area">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div className="privacy-policy-content">
                                    <div className="section-title" style={{marginBottom: '30px'}}>
                                        <h5 className="title">Política de Privacidade — FieltransCarga Unipessoal Lda.</h5>
                                    </div>
                                    
                                    <p>
                                        A FieltransCarga Unipessoal Lda., NIF 515882623, com sede na Rua Dom Afonso Henriques, 1539, 4425-636 Pedrouços – Maia ("FieltransCarga"), respeita a privacidade dos utilizadores do website fielcarga.pt e compromete-se a tratar os dados pessoais de forma lícita, transparente e segura, nos termos do Regulamento (UE) 2016/679 (RGPD) e da legislação aplicável.
                                    </p>

                                    <h4>1) Dados pessoais recolhidos</h4>
                                    <p>
                                        No âmbito do funcionamento do website, a FieltransCarga recolhe apenas os dados estritamente necessários para responder a pedidos de contacto e orçamentos, nomeadamente:
                                    </p>
                                    <ul>
                                        <li>Nome</li>
                                        <li>Endereço de email</li>
                                        <li>Número de telefone</li>
                                        <li>Outras informações fornecidas voluntariamente pelo utilizador na mensagem</li>
                                    </ul>
                                    <p>
                                        O website não recolhe dados fiscais nem dados de faturação.
                                    </p>

                                    <h4>2) Finalidade e fundamento legal</h4>
                                    <p>
                                        Os dados pessoais são tratados exclusivamente para:
                                    </p>
                                    <ul>
                                        <li>Responder a pedidos de contacto e envio de orçamentos</li>
                                    </ul>
                                    <p>
                                        <strong>Fundamento legal:</strong> diligências pré-contratuais a pedido do titular dos dados (art.º 6.º, n.º 1, al. b) do RGPD).
                                    </p>

                                    <h4>3) Publicidade e cookies</h4>
                                    <p>
                                        A FieltransCarga utiliza Google Ads, direcionado apenas para Portugal, para promover os seus serviços.
                                    </p>
                                    <p>
                                        Podem ser utilizados cookies ou tecnologias semelhantes para fins de medição e publicidade, sempre de acordo com a legislação aplicável.
                                    </p>
                                    <p>
                                        O utilizador pode gerir ou desativar cookies através das definições do seu navegador ou do aviso de cookies do website.
                                    </p>

                                    <h4>4) Destinatários dos dados</h4>
                                    <p>
                                        Os dados podem ser tratados por prestadores de serviços técnicos (ex.: alojamento do site, email) estritamente necessários ao funcionamento do website, atuando como subcontratantes e garantindo níveis adequados de proteção.
                                    </p>

                                    <h4>5) Conservação dos dados</h4>
                                    <p>
                                        Os dados pessoais são conservados apenas pelo período necessário para dar seguimento ao pedido de contacto ou orçamento, sendo posteriormente eliminados, salvo obrigação legal em contrário.
                                    </p>

                                    <h4>6) Direitos dos utilizadores</h4>
                                    <p>
                                        Nos termos do RGPD, o utilizador tem direito a:
                                    </p>
                                    <ul>
                                        <li>Acesso aos seus dados</li>
                                        <li>Retificação</li>
                                        <li>Apagamento</li>
                                        <li>Limitação do tratamento</li>
                                        <li>Oposição ao tratamento</li>
                                        <li>Retirada do consentimento, quando aplicável</li>
                                    </ul>
                                    <p>
                                        O exercício destes direitos pode ser feito através de:
                                    </p>
                                    <ul>
                                        <li>Email: <a href="mailto:geral@fielcarga.pt">geral@fielcarga.pt</a></li>
                                        <li>Telefone: <a href="tel:+351914440333">(+351) 914 440 333</a></li>
                                    </ul>

                                    <h4>7) Reclamações</h4>
                                    <p>
                                        O utilizador tem o direito de apresentar reclamação junto da Comissão Nacional de Proteção de Dados (CNPD).
                                    </p>

                                    <h4>8) Alterações à Política de Privacidade</h4>
                                    <p>
                                        A FieltransCarga reserva-se o direito de atualizar esta Política sempre que necessário. Recomenda-se a consulta periódica.
                                    </p>

                                    <p style={{marginTop: '30px', fontStyle: 'italic', color: 'var(--color-body)'}}>
                                        Última atualização: 1 de janeiro de 2025.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CtaLayoutOne />
            <FooterOne parentClass="" />
            </main>
        </>
    )
}

export default PrivacyPolicy;
